<template>
  <div class="mb-2 col-md-4 col-sm-6 col-12">
    <div v-if="label" class="fw-semibold text-capitalize mb-2 ms-1 text-lg">
      {{ label }}
      <span v-if="isRequired" class="ms-1 text-red-800 font-bold"> *</span>
    </div>
    <div>
      <slot/>
    </div>
  </div>
</template>

<script>
export default {
  name: "CustomFormField",
  setup() {
  },
  props: ['label', 'isRequired'],
  data() {
  },
}
</script>


<style scoped>

</style>